import { Types } from "../types";
export var ecommerceTypeFragmentSchema = Types.enum(["navigation", "news", "player shoppable ad", "pulse", "rail", "recent search", "schedule", "search", "sports category", "up next"]);
//# sourceMappingURL=ecommerceTypeFragment.js.map